var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDealerFilterIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 4C1.75 2.75736 2.75736 1.75 4 1.75C5.24264 1.75 6.25 2.75736 6.25 4C6.25 5.24264 5.24264 6.25 4 6.25C2.75736 6.25 1.75 5.24264 1.75 4ZM4 0.25C1.92893 0.25 0.25 1.92893 0.25 4C0.25 6.07107 1.92893 7.75 4 7.75C5.83807 7.75 7.36728 6.42758 7.68809 4.68226C7.78307 4.72575 7.8887 4.75 8 4.75H17C17.4142 4.75 17.75 4.41421 17.75 4C17.75 3.58579 17.4142 3.25 17 3.25H8C7.8887 3.25 7.78307 3.27425 7.68809 3.31774C7.36728 1.57242 5.83807 0.25 4 0.25ZM2 13.25C1.58579 13.25 1.25 13.5858 1.25 14C1.25 14.4142 1.58579 14.75 2 14.75H10.325C10.6725 16.4617 12.1858 17.75 14 17.75C16.0711 17.75 17.75 16.0711 17.75 14C17.75 11.9289 16.0711 10.25 14 10.25C12.1858 10.25 10.6725 11.5383 10.325 13.25H2ZM14 11.75C12.7574 11.75 11.75 12.7574 11.75 14C11.75 15.2426 12.7574 16.25 14 16.25C15.2426 16.25 16.25 15.2426 16.25 14C16.25 12.7574 15.2426 11.75 14 11.75Z",
    fill: "#0562D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerFilterIcon);
export default __webpack_public_path__ + "static/media/dealer-filter-icon.0b52dfe45d3693dc9017fe71d6accbd8.svg";
export { ForwardRef as ReactComponent };